// extracted by mini-css-extract-plugin
export default {"list":"gXQXkc","item":"AJFcpj","button":"z2Si5c","primaryName":"vSRXnk","secondaryName":"LBv2rI","buttonStateActive":"LFsqj2"};